import { concatIf } from '@btime/helpers'
import { useCleanFilterForRequest } from '@btime/react-contexts'
import { useIsOwner, useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React, { Fragment } from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../packages/kiti/components/presentation/Text'
import { useNavigation } from '../../../utils/contexts/NavigationContext'
import {
  useOpenEditFieldsModal,
  useOpenExportHistoryModal,
  useOpenExportModal,
  useOpenImportHistoryModal,
  useOpenPublicTokensModal,
  useOpenTemplatesModal
} from '../../../utils/routes/modals/modalsActions'
import DropdownLink from '../../../components/navigation/DropdownLink'
import IconText from '../../../components/presentation/IconText'
import Separator from '../../../components/helpers/Separator'

const PageHeader = () => {
  const openEditFieldsModal = useOpenEditFieldsModal()
  const openImportHistoryModal = useOpenImportHistoryModal()
  const openExportHistoryModal = useOpenExportHistoryModal()
  const openTemplatesModal = useOpenTemplatesModal()
  const openPublicTokensModal = useOpenPublicTokensModal()
  const openExportModal = useOpenExportModal()

  const { t } = useTranslation(['common', 'listUsers'])
  const navigate = useNavigation()

  const isOwner = useIsOwner()
  const canEdit = useSessionPermission('editUser')
  const canExport = useSessionPermission('exportUser')
  const canImport = useSessionPermission('importUser')
  const canSetup = useSessionPermission('setupUser')
  const canListTemplate = useSessionPermission('listTemplate')
  const canListPublicToken = useSessionPermission('listPublicToken')
  const canCreateGroup = useSessionPermission('createUserGroup')

  const filter = useCleanFilterForRequest()

  const options = [
    ...concatIf(canListTemplate, [
      {
        value: 'templates',
        iconLeft: 'RiFileCopy2Line',
        onClick: () => openTemplatesModal('user')
      },

      { line: true }
    ]),

    ...concatIf(canImport, [
      {
        value: 'import',
        iconLeft: 'RiUploadCloud2Line',
        onClick: () => navigate(`/import/v2/user`)
      },
      {
        value: 'importHistory',
        iconLeft: 'RiTimeLine',
        onClick: () => openImportHistoryModal('user')
      },

      { line: true }
    ]),

    ...concatIf(canExport, [
      {
        value: 'export',
        iconLeft: 'RiDownloadCloud2Line',
        onClick: () => openExportModal({ entity: 'user', filter })
      },
      {
        value: 'exportHistory',
        iconLeft: 'RiTimeLine',
        onClick: () => openExportHistoryModal('user')
      },

      { line: true }
    ]),

    ...concatIf(canListPublicToken, [
      {
        value: 'publicToken',
        iconLeft: 'BsReply',
        onClick: () => openPublicTokensModal('user')
      },

      { line: true }
    ]),

    ...concatIf(canSetup, [
      {
        value: 'fields',
        iconLeft: 'RiListSettingsLine',
        onClick: () => openEditFieldsModal('contracts')
      }
    ]),
    ...concatIf(canSetup && canCreateGroup, [
      {
        value: 'group',
        iconLeft: 'RiListSettingsLine',
        onClick: () => navigate('/groups')
      }
    ])
  ]

  return (
    <Fragment>
      <Grid justify="space-between" align="center" gutter={0.4}>
        <Col>
          <Title size="h2" color="dark3" noWrap>
            {t('listUsers:title')}
          </Title>
        </Col>
        {/* TODO: Take it back after migrate intercom articles to another place */}
        {/* <Col>
          <PageGuide />
        </Col> */}
        <Col flex={1} />
        {!!options.length && (
          <Col>
            <DropdownLink
              fromRight
              t={key => t(`listUsers:menu.${key}`)}
              options={options}
              actionContent={
                <IconText label={t('moreOptions')} iconName="BsThreeDotsVertical" noWrap size="small" bold />
              }
            />
          </Col>
        )}
      </Grid>

      <Separator weight={2} />
    </Fragment>
  )
}

export default PageHeader
